import { render } from "./TechnologiesSection.vue?vue&type=template&id=161d55ca&scoped=true"
import script from "./TechnologiesSection.vue?vue&type=script&lang=js"
export * from "./TechnologiesSection.vue?vue&type=script&lang=js"

import "./TechnologiesSection.vue?vue&type=style&index=0&id=161d55ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161d55ca"]])

export default __exports__